import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '../../app/AppStyles';
import { fetchFavorites } from '../favorites/favoritesSlice';
import BackButton from '../subcomponents/BackButton';
import ContentLoader from '../subcomponents/ContentLoader';
import FilterButton from '../subcomponents/FilterButton';
import FilterSidebar from '../subcomponents/FilterSidebar';
import PageLayout from '../subcomponents/PageLayout';
import RegisterPerformancesCard from './RegisterPerformancesCard';
import { fetchRegister, setPerformance, setPerformances } from './registerSlice';

export default function RegisterPerformancesPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id, name } = useParams();

    const { register, registerStatus, performances, performancesStatus } = useSelector((state) => state.register);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { student } = useSelector((state) => state.student);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { activeDepartment, departmentThemesStatus } = useSelector((state) => state.settings.theme);

    const [inRooster, setInRooster] = useState(false);

    useEffect(() => {
        if (student !== null && registerStatus !== "success") {
            dispatch(setPerformance(null));

            if (siomSettings.useMultipleDepartments) {
                if (activeDepartment !== null) {
                    navigate("/inschrijven");
                };
            } else {
                dispatch(fetchRegister(null));
                dispatch(fetchFavorites(null));
            };
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, student, departmentThemesStatus, activeDepartment, siomSettings]);

    useEffect(() => {
        if (registerStatus === "success" && performances === null) {
            dispatch(setPerformances(register?.registerActivities?.find(item => item.activityId === id)?.activityPerformances));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, registerStatus, id]);

    const handleChange = () => {
        setInRooster(!inRooster);
    };

    const FilterFragment = () => {
        return (
            <FormGroup>
                <FormControlLabel control={<Checkbox checked={inRooster} onChange={handleChange} />} label={`${resourceFinal[appLanguage].messages.ALWAYS_AVAILABLE_CHECKBOX}`} />
            </FormGroup>
        );
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.PERFORMANCES}
            content={
                <ContentLoader
                    successCondition={performancesStatus === "success"}
                    errorCondition={performancesStatus === "failed"}
                    content={
                        <>
                            <Grid container spacing={1} justifyContent="center" alignItems="flex-start">
                                <Grid size={{ xs: 12 }}><Typography sx={{ ...PageHeader, typography: { xs: 'h5', md: 'h3' } }}>{decodeURIComponent(name)}</Typography></Grid>
                                {inRooster ?
                                    <>
                                        {performances?.filter((item) => item.inRooster === true).length > 0 ?
                                            performances?.filter((item) => item.inRooster === true).map((item) =>
                                                <Grid size={{ xs: 12, md: 6 }} key={item.performanceId}>
                                                    <RegisterPerformancesCard performance={item} />
                                                </Grid>
                                            ) : <Grid size={{ xs: "grow" }}><Typography variant="h6" textAlign="center">{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</Typography></Grid>}
                                    </>
                                    :
                                    <>
                                        {performances?.length > 0 ?
                                            performances?.map((item) =>
                                                <Grid size={{ xs: 12, md: 6 }} key={item.performanceId}>
                                                    <RegisterPerformancesCard performance={item} />
                                                </Grid>
                                            ) : <Grid size={{ xs: "grow" }}><Typography variant="h6" textAlign="center">{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</Typography></Grid>}
                                    </>
                                }
                            </Grid>
                        </>
                    }
                />
            } contentLeft={
                <FilterSidebar filters={<FilterFragment />} />
            } contentBottom={
                <FilterButton filters={<FilterFragment />} />
            } contentRight={
                <BackButton desktop />
            }
            bottomBar
            disableHeaderBackground
            disableContentBackground
        />
    );
}
